module.exports = "/static/assets/f3141e783e3d0ee5bbdb3ec7d1fba24c.gif";